import React, { useState } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import SmallHeading from 'components/SmallHeading';
export default function PasswordProtect(props) {
    const [ isPasswordSubmitting, setIsPasswordSubmitting ] = useState(false);
    const [ enteredPassword, setEnteredPassword ] = useState('');
    const [ isLocalPasswordCorrect, setIsLocalPasswordCorrect ] = useState(false);
    const [ invalidPassword, setInvalidPassword ] = useState(false);

    const submitPassword = function() {
        if (isPasswordSubmitting) {
            return;
        }

        setIsPasswordSubmitting(true);

        // Check against the specific password for this component
        if (enteredPassword === props.password) {
            setIsLocalPasswordCorrect(true);
            setInvalidPassword(false);
        } else {
            setInvalidPassword(true);
        }

        setIsPasswordSubmitting(false);
    };

    const onSubmitPassword = function(e) {
        e.preventDefault();
        submitPassword();
    };


    if (!isLocalPasswordCorrect) {
        return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <Box component="form" onSubmit={onSubmitPassword} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '500px',
                width: '100%' }}>
                <SmallHeading>Enter password</SmallHeading>
                <TextField sx={{ marginTop: '10px' }}
                    value={enteredPassword}
                    size="small" onChange={ (e) => {
                        setEnteredPassword(e.target.value);
                        if (invalidPassword) {
                            setInvalidPassword(false);
                        }
                    } }
                    label="Enter Password" />
                { isPasswordSubmitting ? <CircularProgress sx={{ marginTop: '10px' }} /> :
                    <Button sx={{ marginTop: '10px' }} type="submit"
                        variant="outlined">Submit</Button>
                }
                {invalidPassword && (
                    <Alert
                        severity="error"
                        icon={false}
                        sx={{
                            marginTop: '12px',
                            width: '100%',
                            maxWidth: '340px',
                            justifyContent: 'center',
                            '& .MuiAlert-message': {
                                width: '100%',
                                textAlign: 'center'
                            }
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <ErrorOutlineIcon sx={{ fontSize: 20, color: '#d32f2f' }} />
                            <span>Invalid Password</span>
                        </Box>
                    </Alert>
                )}
            </Box>
        </Box>);
    } else {
        return (
            <>{ props.children }</>
        );
    }
}
